import {AfterViewInit, Directive, ElementRef, Input} from '@angular/core';

@Directive({
  selector: '[vbAutofocus]',
  exportAs: 'vbAutofocus',
})
export class AutofocusDirective implements AfterViewInit {

  private _focus = true;

  @Input() set autofocus(condition: boolean) {
    this._focus = condition !== false;
  }

  constructor(private el: ElementRef) {

  }

  ngAfterViewInit() {
    if (this._focus) {
      this.placeFocus();
    }
  }

  public placeFocus() {
    // Use setTiemout so the focus is set after the next CD run
    setTimeout(() => {
      /* For SSR (server side rendering) this is not safe.
      Use: https://github.com/angular/angular/issues/15008#issuecomment-285141070)
     */
      this.el.nativeElement.focus();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/directives/autofocus.directive.ts